import { BaseComponent } from "../../Library/BaseComponent";
import { OnInit, Component, Input, Output, EventEmitter } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import { MasterDataService } from "../../Services/MasterDataService";
import { QuestionSetStatus } from "../../Models/EnumModels";
import { StaffHealthDataService } from "../../Services/StaffHealthDataService";
import { StaffQuestionaireTemplate, QuestionSetDetail } from "../../Models/ResponseModels";


@Component({
    selector: 'QuestionnairePopover',
    templateUrl: './QuestionnairePopover.html'
})
export class QuestionnairePopover extends BaseComponent implements OnInit {

    Model?: StaffQuestionaireTemplate;
    ModelDetail?: QuestionSetDetail;
    DateFormat: string;

    QuestionSetStatus = QuestionSetStatus;

    @Input() set Selected(data: StaffQuestionaireTemplate) {
        if (this.Model != null && data != null && this.Model.Id == data.Id && !data['forceUpdate']) {
            return;
        }

        this.ModelDetail = null;
        this.Model = data;
        if (this.Model && this.Model.PropertyId) {
            this.DateFormat = this.masterService.GetPropertyDateFormat(this.Model.PropertyId);
        }
        this.open();
    }

    @Output() onAction = new EventEmitter();

    constructor(
        public translate: TranslateService,
        public toastr: ToastrService,
        public route: ActivatedRoute,
        public router: Router,
        public masterService: MasterDataService,
        protected staffHealthService: StaffHealthDataService) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnInit() { }

    open() {
        this.setData();
    }

    setData() {
        this.ClearErrors();

        if (!this.Model || !this.Model.Id || !this.Model.PropertyId) {
            return;
        }
        this.IsSubmitting = true;
        this.staffHealthService.GetQuestionaireById(this.Model.PropertyId, this.Model.Id)
            .then(data => {
                this.IsSubmitting = false;
                if (data.HasError) {
                    this.FormErrors = data.Errors;
                    return;
                }
                this.ModelDetail = data.Result;
            }, error => {
                this.IsSubmitting = false;
                console.error(error);
            });
    }

    didTakeAction(action: string) {

        this.Model && this.onAction.emit({
            action: action,
            model: this.Model
        });
    }
}
